import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import HrbTranslate from '../../../components/language/HrbTranslate'
import PresaleStatusBadge from '../../../components/library/badges/PresaleStatusBadge'
import LoadingText from '../../../components/library/layout/LoadingText'

const PresaleStatus = (props) => {
    const { presale } = props;

    return (
        <Fragment>
            <div className='columns tickets level'>
                <div className='column is-1' />
                <div className='column is-4'>
                    <div className='tax-year-holder'>
                        <h4>
                            <LoadingText
                                textKey={'PresaleInfo.Headers.Information'}
                                params={{ TaxYear: presale ? presale.taxYear : 0 }}
                                loading={!presale}
                                isEmpty={presale && !presale.taxYear} />                        
                        </h4>                        
                    </div>
                </div>
                <div className='column is-6'>
                    <div className='status-holder'>
                        <h4><HrbTranslate text='PresaleInfo.Labels.Status' /></h4>
                        <PresaleStatusBadge status={presale ? presale.status : ''} />                        
                    </div>
                </div>
                <div className='column is-1' />
            </div>
        </Fragment>
    );
}

PresaleStatus.whyDidYouRender = false;

PresaleStatus.propTypes = {
    presale: PropTypes.object,
    lang: PropTypes.string
}

export default PresaleStatus